module.exports = __webpack_public_path__ + "img/hr-tree-06-a-trunk.d1792426.png";